module.exports = __webpack_public_path__ + "media/10_5.ad20def6.wav";